// import { dataUpload } from '../../firestoreData/dataUpload';

import _ from "lodash"

export const rts = {
  handleAmmend_startConfirmation: 'handleAmmend_startConfirmation',
  handleAmmend_startDimmer: 'handleAmmend_startDimmer',
  handleAmmend_useEffect: 'handleAmmend_useEffect',
  handleAmmend_useMemo: 'handleAmmend_useMemo',
  handleKillDimmer: 'handleKillDimmer',
  handleTimeLeft: 'handleTimeLeft',
}


export const startTexts = {
  app: 'Loading',
  authorizing: 'Authorizing',
  settings: 'Loading',
  createEvent: 'Creating Event',
  pending: 'Pending Authorization',
  retrieving: 'Retrieving',
  fetchingRegEvent: 'Fetching Reg Event',
}

export const startTypes = {
  app: 'app',
  authorizing: 'authorizing',
  createEvent: 'createEvent',
  fetchingReg: 'fetchingReg',
  event: 'event',
  finish: 'finish',
  pageItem: 'pageItem',
  retrieving: 'retrieving',
  suspense: 'suspense',
}

export const startConfirmationTypes = {
  // appValidated: 'appValidated',
  // authAccepted: 'authAccepted',
  authConfirmed: 'authConfirmed',
  authValidated: 'authValidated',
}

const getPathKeys = () => {
  const url = window.location?.hash; // Get the path without the domain
  const clientMatch = url.match(/clients\/([^/]+)/);
  const eventMatch = url.match(/events\/([^/]+)/);
  const clientKey = clientMatch ? clientMatch[1] : null;
  const eventKey = eventMatch ? eventMatch[1] : null;
  return { clientKey, eventKey }
}

export const startReducer = (state, action) => {

  const _pathKeys = getPathKeys()

  const { killInterval, startConfirmations } = state
  const { type } = action

  switch (type) {

    case rts.handleAmmend_useMemo:
      const _payloads_memo = { ...state.payloads_memo }
      if (!_payloads_memo[action.effectName]) {
        _payloads_memo[action.effectName] = []
      }
      _payloads_memo[action.effectName].push(new Date())
      return { ...state, payloads_memo: _payloads_memo }

    case rts.handleAmmend_useEffect:
      const _payloads_effect = { ...state.payloads_effect }
      if (!_payloads_effect[action.effectName]) {
        _payloads_effect[action.effectName] = []
      }
      _payloads_effect[action.effectName].push(action.timestamp)
      return { ...state, payloads_effect: _payloads_effect }

    case rts.handleAmmend_startConfirmation:
      const { startConfirmationType, origin: ogn } = action;
      const _startConfirmations = { ...startConfirmations }
      if (startConfirmationType) {
        _startConfirmations[startConfirmationType] = true
      }
      return { ...state, startConfirmations: _startConfirmations }

    case rts.handleAmmend_startDimmer:

      const { startType, origin, settingsDocName } = action;

      // If no startType: turn dimmer off and exit
      if (!startType) {
        return {
          ...state,
          origin,
          startDimmerOn: false,
          startType: null,
          killDimmer: true,
        };
      }

      // Handle "finish" directly
      if (startType === startTypes.finish) {
        return {
          ...state,
          origin,
          startDimmerOn: false,
          startType,
          startCaption: "Finishing",
          killDimmer: true,
        };
      }

      // Step 1: pick base caption from map
      const baseCaptions = {
        [startTypes.app]: startTexts.app,
        [startTypes.authorizing]: startTexts.authorizing,
        [startTypes.createEvent]: startTexts.createEvent,
        [startTypes.event]: startTexts.settings,
        [startTypes.retrieving]: startTexts.retrieving,
        [startTypes.fetchingReg]: startTexts.fetchingRegEvent,
      };
      let caption = baseCaptions[startType] || "Loading";

      // Step 2: add context suffix
      if (_pathKeys.eventKey) caption += " Event";
      else if (_pathKeys.clientKey) caption += " Client";

      // Step 3: override/append based on startType
      if (startType === startTypes.authorizing) {
        caption = "Authorizing...";
      } else if (
        [startTypes.app, startTypes.event, startTypes.suspense, startTypes.retrieving].includes(startType)
      ) {
        caption += " App...";
      }

      // Final special case (note: this will override the above if suspense)
      if (startType === startTypes.suspense) {
        caption = "Please wait...";
      }

      return {
        ...state,
        origin,
        startDimmerOn: true,
        startType,
        startCaption: caption,
        startDocName: settingsDocName,
      };


    case rts.handleTimeLeft:
      return { ...state, timeLeft: killInterval - 1 }

    case rts.handleKillDimmer:
      return { ...state, startDimmerOn: false, startType: null, killDimmer: true }

    default:
      return { ...state }
  }
}

export const startInitialState = (initState) => {
  return { startDimmerOn: true, ...initState, payloads_effect: {}, startConfirmations: { authValidated: false, authConfirmed: false } }
};

export const startHandlers = (dispatch) => {
  return {
    handleAmmend_startConfirmation: (startConfirmationType, origin) => { dispatch({ type: rts.handleAmmend_startConfirmation, startConfirmationType, origin }) },
    handleAmmend_startDimmer: (startType, origin, settingsDocName) => { dispatch({ type: rts.handleAmmend_startDimmer, startType, origin, settingsDocName }) },
    handleAmmend_useEffect: (effectName, data) => { dispatch({ type: rts.handleAmmend_useEffect, effectName, data }) },
    handleAmmend_useMemo: (effectName, data) => { dispatch({ type: rts.handleAmmend_useMemo, effectName, data }) },
    handleKillDimmer: () => { dispatch({ type: rts.handleKillDimmer }) },
    handleTimeLeft: () => { dispatch({ type: rts.handleTimeLeft }) },
  }
}